module.exports = "fragment SocialSharing on SocialSharing {\n  __typename\n  welcomeMessage\n  shareLink\n}\n"